import { openLoginBox } from "./app.js";
import { getLocalInspectionsInStatus } from "../data/inspections.js";

export const FETCH_COMPLETED_INSPECTIONS_BEGIN =
	"FETCH_COMPLETED_INSPECTIONS_BEGIN";
export const FETCH_COMPLETED_INSPECTIONS_SUCCESS =
	"FETCH_COMPLETED_INSPECTIONS_SUCCESS";
export const FETCH_COMPLETED_INSPECTIONS_ERROR =
	"FETCH_COMPLETED_INSPECTIONS_ERROR";

const fetchCompletedInspectionsBegin = () => ({ type: FETCH_COMPLETED_INSPECTIONS_BEGIN });

const fetchCompletedInspectionsSuccess = inspections => ({
	type: FETCH_COMPLETED_INSPECTIONS_SUCCESS,
	payload: inspections
});

const fetchCompletedInspectionsError = error => ({
	type: FETCH_COMPLETED_INSPECTIONS_ERROR,
	payload: { error }
});

export function fetchCompletedInspections() {
	return async (dispatch, getState) => {
		dispatch(fetchCompletedInspectionsBegin());

		const s = getState();
		let remote = await fetch(
			window.INSP.config.apiUrl +
			"/api/inspection/getGroupedCompletedInspections",
			{
				method: "get",
				headers: { Authorization: "Bearer " + s.app.token }
			}
		)
			.then(r => handleErrors(r, dispatch))
			.then(res => res.json())
			.catch(error => dispatch(fetchCompletedInspectionsError(error)));

		let all = await mergeRemoteAndLocalInspections(Array.isArray(remote) ? remote : []);


		dispatch(fetchCompletedInspectionsSuccess(all));
	};
}

async function mergeRemoteAndLocalInspections(remote) {
	let res = await getLocalInspectionsInStatus("done")
		.then(a => a || []).then(l => {

			for (let i of l) {
				let cGroup = remote.find(j => j.customerId === i.customerId);
				if (cGroup) {
					let pGroup = cGroup.projects.find(p => p.name === i.projectName);
					if (pGroup) {
						pGroup.inspections.push({ _key: i._key, name: i.name, date: i.date, type: { name: i.type.name } });
					} else {
						cGroup.projects.push({
							projectName: i.projectName,
							inspections: [{ _key: i._key, name: i.name, date: i.date, type: { name: i.type.name } }]
						});
					}
				} else {
					remote.push({
						customerId: i.customerId,
						customerName: i.customerName,
						projects: [{
							projectName: i.projectName,
							inspections: [{ _key: i._key, name: i.name, date: i.date, status: i.status, type: { name: i.type.name } }]
						}]
					});
				}
			}

			return remote;
		})

	return res;
}

function handleErrors(response, dispatch) {
	if (!response.ok)
		if (response.status == 401) {
			dispatch(openLoginBox());
		}

	return response;
}
